<template>
  <auth-layout :fortyPercentWidth="true">
    <div class="login-area">
      <div class="header">
        <h1 class="heading">Login To Your Account</h1>
      </div>
      <div class="main-form-area">
        <form @submit.prevent>
          <div>
            <input
              type="text"
              class="auth-input-field"
              placeholder="Email Address"
              autocomplete="email"
              v-model="user.email"
            />
          </div>{{ loggingIn }}
          <div class="password-input-field_wrapper">
            <div class="view-password" @click="showPassword('password')">
              <show-password-icon />
            </div>
            <input
              type="password"
              id="password"
              class="auth-input-field no-bottom-margin"
              placeholder="Password"
              v-model="user.password"
            />
            <div class="pt-3">
              <router-link to="/forgot-password">Forgot Password?</router-link>
            </div>
          </div>
          <div>
            <button class="btn" :disabled="disableLoginButon" @click="login">
              <button-loader v-if="loggingIn" /> <span v-else>Login</span>
            </button>
          </div>
        </form>
      </div>

      <div class="no-account">
        <small>
          Don't have an account?
          <span>
            <router-link to="/signup">Sign Up</router-link>
          </span>
        </small>
      </div>
    </div>
  </auth-layout>
</template>

<script>
import AuthLayout from "../Authlayout/AuthLayout";
export default {
  components: {
    AuthLayout,
  },
  data() {
    return {
      user: {
        email: "",
        password: "",
      },
      loggingIn: false,
    };
  },
  computed: {
    disableLoginButon() {
      let { email, password } = this.user;
      let validate = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      // Removes any space that might have been accidentally added to the amail and might prevent it from being
      // accepted as valid
      let filteredEmail = email.replace(/\s/g, "");
      let validEmail = validate.test(filteredEmail);
      if (email.length && password.length && validEmail) {
        return false;
      } else {
        return true;
      }
    },
  },
  methods: {
    async login() {
      this.loggingIn = true;
      try {
        let response = await this.$_login(this.user);
        // let quantum_response = await this.$_quantumLogin(this.user);
        console.log(response);
        console.log(response.data.data.quantumToken)
        // console.log(quantum_response);
        this.handleSuccessfulLogin(response);
        // this.handleSuccessfulLoginQuantum(quantum_response);
      } catch (error) {
        this.loggingIn = false;
        this.handleError(error);
        console.log(error);
      }
    },
    // handleSuccessfulLoginQuantum(response) {
    //   // localStorage.clear();
    //   this.$_setAuthHeader();
    //   if (response.data.users.twoFA) {
    //     localStorage.setItem("userId", response.data.users.id);
    //     this.$router.push({ name: "VerifyOtp" });
    //   } else {
    //     this.saveOrganizationId(response);

    //     this.$store.dispatch("saveUserDetails", response.data.users);
    //     this.$store.dispatch(
    //       "saveOrganizationDetails",
    //       response.data.users.Orgs[0]
    //     );
    //     this.$store.dispatch("setToken", response.data.tokens);
    //     localStorage.setItem("userId", response.data.users.id);
    //     this.generateToast(`Welcome`, "success");
    //     this.$router.push("/settings");
    //   }
    // },
    handleSuccessfulLogin(response) {
      // localStorage.clear();
      this.$_setAuthHeader();
      if (response.data.users.twoFA) {
        localStorage.setItem("userId", response.data.users.id);
        this.$router.push({ name: "VerifyOtp" });
      } else {
        this.saveOrganizationId(response);

        this.$store.dispatch("saveUserDetails", response.data.users);
        this.$store.dispatch(
          "saveOrganizationDetails",
          response.data.users.Orgs[0]
        );
        this.$store.dispatch("setToken", response.data.tokens);
        localStorage.setItem("userId", response.data.users.id);
        this.generateToast(`Welcome`, "success");
        this.$router.push("/3pl/dashboard");
      }
    },
    saveOrganizationId(response) {
      let organizationInformation = response.data.users.Orgs;
      if (organizationInformation.length > 0) {
        let organizationId = response.data.users.Orgs[0].id;
        this.$store.dispatch("saveOrganizationId", organizationId);
        localStorage.setItem("organizationId", organizationId);
      } else {
        return;
      }
    },
    showPassword(passwordField) {
      var password = document.getElementById(passwordField);
      if (password.type === "password") {
        password.type = "text";
      } else {
        password.type = "password";
      }
    },
  },
};
</script>

<style scoped>
.header {
  margin-bottom: 3rem;
}
.login-area {
  width: 90%;
  margin: 0 auto;
}
.auth-input-field {
  margin-bottom: 3rem;
}
.forgot-password {
  color: #0253b3;
  font-weight: 400;
  padding-top: 0.5rem;
}
.no-bottom-margin {
  margin-bottom: 0;
}
.btn {
  margin: 2rem 0;
}
.password-input-field_wrapper {
  position: relative;
}
.view-password svg {
  position: absolute;
  right: 1rem;
  top: 1rem;
  opacity: 0.5;
  cursor: pointer;
}
@media screen and (max-width: 768px) {
  .login-area {
    width: 100%;
  }
}
</style>
